<script setup>
import { Head, useForm } from '@inertiajs/inertia-vue3';
import BlankLayout from '../../Layouts/BlankLayout';
import Icone from '../../Componentes/Global/Icone';
import useRotas from '../../Composables/useRotas';
import {computed} from "vue";

const route = useRotas();

const form = useForm({
    username: null,
    senha: null,
    remember: false,
})

const doulheTresConfig = computed(() => window.doulheTresConfig);

</script>

<template>
    <Head title="Entrar" />
    <BlankLayout>
        <q-page class="flex row justify-center items-center">
            <div class="flex column items-center col-11 col-md-5" >
                <icone height="7em" width="14em" />
                <h6 class="text-center text-primary font-weight-light q-my-md">
                    Bem vindo à {{doulheTresConfig?.nome}}
                </h6>
                <q-form class="full-width" @submit="form.post(route('auth.login.processar'))">
                    <q-input
                        v-model="form.username"
                        :rules="[ val => val && val.length > 0 || 'Por favor digite seu email']"
                        class="full-width"
                        color="primary"
                        dense
                        label="Digite seu Email"
                        label-color="primary"
                        lazy-rules
                        type="email"
                    />
                    <q-input
                        v-model="form.senha"
                        :rules="[
                            val => val !== null && val !== '' || 'Por favor digite sua senha'
                        ]"
                        class="full-width"
                        color="primary"
                        dense
                        label="Digite sua Senha"
                        label-color="primary"
                        lazy-rules
                        type="password"
                    />
                    <q-toggle
                        v-model="form.remember"
                        :rue-value="true"
                        :false-value="false"
                        class="full-width q-mb-md"
                        color="primary"
                        dense
                        label="Confiar neste dispositivo" type="checkbox" />
                    <q-btn
                        class="full-width"
                        color="primary"
                        label="Entrar"
                        type="submit"
                        :loading="form.processing"
                    />
                    <q-btn
                        class="full-width q-mt-sm"
                        color="primary"
                        flat
                        label="Esqueci Minha Senha"
                        type="button"
                        @click="$inertia.visit(route('auth.login.redefinirSenha'))"
                    />
                </q-form>
            </div>
        </q-page>
    </BlankLayout>
</template>
